import styled from 'styled-components'
import { BREAKPOINTS } from 'styles/constants'
import Button from 'ui/components/buttons/Button'
import Switch from 'ui/components/forms/Switch'

export const Wrapper = styled.div`
  padding-top: 23px;
  border-top: 1px solid var(--t-separator-border-secondary);
`

export const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const UserList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 20px;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    grid-template-columns: 1fr;
  }
`

export const UserRoleLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 15px;
  color: var(--p-blue-580);
`

export const UserRoleButton = styled(Button)`
  max-width: 214px;
`

export const UserListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding-right: ${({ $hasVerticalScroll }) =>
    $hasVerticalScroll ? '12px' : '0'};
`

export const UserElem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`

export const UserCard = styled.div`
  width: calc(100% - 30px);
`

export const UserDelete = styled.div`
  width: 30px;
`

export const ControlIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const UserStatusSwitch = styled(Switch)`
  margin-bottom: 14px;

  > span:last-child {
    margin-left: 0;
  }
`
